import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "item-head"
};
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = {
  class: "text"
};
const _hoisted_5 = {
  class: "footer"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "btns"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
import { ref, onMounted } from "vue";
import CustomBar from "@/components/customBar";
import { addressList, setDefaultAddress, deleteAddress } from "@/api/index";
import Empty from "@/components/empty";
import { useStore } from "@/store/index";
import { usebaseRouter } from "@/utils/hooks";

import { showConfirmDialog, showToast } from 'vant/es';
import 'vant/es/dialog/style/index';
import 'vant/es/toast/style/index';
export default {
  __name: 'index',
  setup(__props) {
    const {
      back,
      getQuery
    } = usebaseRouter();
    const store = useStore();
    const {
      type
    } = getQuery();
    const list = ref([]);
    const useSite = item => {
      store.$state.shippingAddress = item;
      back(0);
    };
    const addressListFn = () => {
      addressList().then(res => {
        list.value = res || [];
      });
    };
    const deleteAddressFn = addressid => {
      showConfirmDialog({
        title: '提示',
        message: '是否确认删除该地址？'
      }).then(() => {
        deleteAddress({
          addressid
        }).then(res => {
          showToast('删除成功');
          addressListFn();
          store.getDefaultAddressFn();
        });
      });
    };
    const setDefaultAddressFn = item => {
      if (item.isDefault) return;
      setDefaultAddress({
        addressid: item.addressid
      }).then(res => {
        showToast('设置成功');
        addressListFn();
        store.getDefaultAddressFn();
      });
    };
    onMounted(() => {
      addressListFn();
    });
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_floating_bubble = _resolveComponent("van-floating-bubble");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: "填写收货地址"
      }), _createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.receiver) + " " + _toDisplayString(item.mobile), 1), _createVNode(_component_van_icon, {
          name: "cross",
          size: "15",
          color: "#999999",
          onClick: $event => deleteAddressFn(item.addressid)
        }, null, 8, ["onClick"])]), _cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "line"
        }, null, -1)), _createElementVNode("div", _hoisted_4, _toDisplayString(item.province) + " " + _toDisplayString(item.city) + " " + _toDisplayString(item.area) + " " + _toDisplayString(item.address), 1), _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "line"
        }, null, -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
          class: _normalizeClass(["left", item.isDefault ? 'active' : '']),
          onClick: $event => setDefaultAddressFn(item)
        }, _toDisplayString(item.isDefault ? '已设为默认' : '默认'), 11, _hoisted_6), _createElementVNode("div", _hoisted_7, [_unref(type) == 1 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "btns-item",
          onClick: $event => useSite(item)
        }, "使用", 8, _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "btns-item",
          onClick: $event => _ctx.$router.push({
            path: 'addSite',
            query: item
          })
        }, "修改", 8, _hoisted_9)])])]);
      }), 128))]), _createVNode(_component_van_floating_bubble, {
        icon: "plus",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('addSite'))
      }), list.value.length == 0 ? (_openBlock(), _createBlock(_unref(Empty), {
        key: 0,
        text: "暂无收货地址"
      })) : _createCommentVNode("", true)], 64);
    };
  }
};